import { useCallback, useMemo } from "react";
import type { SavedViewConfig } from "../../../../UniversalCRMTable/types";
import type { TabItem } from "../types";

export const useTabsData = (allViews: SavedViewConfig[] | undefined) => {
  // Memoize tabs to prevent unnecessary re-renders
  const tabs = useMemo(
    () =>
      [
        { id: null, name: "Main" },
        ...(allViews || []).map((view) => ({
          id: view.id,
          name: view.name,
        })),
      ] as TabItem[],
    [allViews]
  );

  // Check if a view is a user-created saved view (not a config preset)
  const isUserCreatedView = useCallback(
    (viewId: string): boolean => {
      const view = allViews?.find((v) => v.id === viewId);
      return !!(view && "created_by" in view);
    },
    [allViews]
  );

  return { tabs, isUserCreatedView };
};
